import { FEEDBACK_TYPES, FEEDBACK_STATUSES } from '../enums/FeedbackEnumFrontend';

const toDisplayLabel = (value) =>
  String(value)
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

const buildLabelMap = (enumObj) =>
  Object.freeze(
    Object.values(enumObj).reduce((acc, entryValue) => {
      acc[entryValue] = toDisplayLabel(entryValue);
      return acc;
    }, {}),
  );

const buildSelectOptions = (enumObj, labelMap) =>
  Object.freeze(
    Object.values(enumObj).map((value) => ({
      value,
      label: labelMap[value],
    })),
  );

export const FEEDBACK_TYPE_LABELS = buildLabelMap(FEEDBACK_TYPES);
export const FEEDBACK_STATUS_LABELS = buildLabelMap(FEEDBACK_STATUSES);

export const FEEDBACK_TYPE_OPTIONS = buildSelectOptions(FEEDBACK_TYPES, FEEDBACK_TYPE_LABELS);
export const FEEDBACK_STATUS_OPTIONS = buildSelectOptions(FEEDBACK_STATUSES, FEEDBACK_STATUS_LABELS);

export const FEEDBACK_TYPE_SCHEMA_VALUES = Object.freeze(Object.values(FEEDBACK_TYPES));
export const FEEDBACK_STATUS_SCHEMA_VALUES = Object.freeze(Object.values(FEEDBACK_STATUSES));

export const FEEDBACK_TYPE_HELPER_TEXT = Object.freeze({
  [FEEDBACK_TYPES.BUG_REPORT]: 'Describe what happened and what you expected to happen.',
  [FEEDBACK_TYPES.CONFUSING_FLOW]: 'Describe what was confusing and where you got stuck.',
  [FEEDBACK_TYPES.FEATURE_REQUEST]: 'Describe the capability you need and why it would help your workflow.',
});

export const getFeedbackTypeLabel = (type) =>
  FEEDBACK_TYPE_LABELS[type] || toDisplayLabel(type);

export const getFeedbackStatusLabel = (status) =>
  FEEDBACK_STATUS_LABELS[status] || toDisplayLabel(status);

export const normalizeCurrentRoutePath = (route = '') => {
  const trimmed = String(route).trim();
  if (!trimmed) return '';

  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const url = new URL(trimmed);
      return `${url.pathname}${url.search}`;
    } catch {
      // fall through to path + query cleanup
    }
  }

  return trimmed.split('#')[0];
};

export const getCurrentRoutePath = () =>
  normalizeCurrentRoutePath(`${window.location.pathname}${window.location.search}`);
